import { h } from 'preact';
import React from 'react';

import './SafeArea.css';

/*
 *  This component should be the outermost component
 *  Pass in a "veil" if desired, necessary to allow it outside of the "safe area"
 *
*/
export const SafeArea = ({ children, veil, safeBottom }) => {
  safeBottom = safeBottom === false ? false : true;
  return (
    <React.Fragment>
      {veil}
      <div class={"message-safe-area-holder" + (safeBottom ? ' message-safe-area-holder--safe-bottom' : '')}>
        <div class="message-safe-area">{children}</div>
      </div>
    </React.Fragment>
  )
}